import React from "react";
import { Link } from "gatsby";
import styled from "@emotion/styled";

// Global Vars
import dimensions from "styles/dimensions";

const NavItem = styled(Link)`
  margin: 0;
  display: block;
  position: relative;
  padding: 8px 0;
  line-height: 1;
  font-size: 24px;
  font-weight: 500;
  color: #303030;
  text-decoration: none;

  @media(min-width: ${dimensions.minwidthTablet}px) {
    font-size: calc(2rem + 1.125vw - 3.6px);
  }

  @media(min-width: ${dimensions.minwidthDesktop}px) and (min-height: ${dimensions.minwidthTablet}px) {
    line-height: 1;
    font-size: 50px;
    padding: 16px;
  }

  span {
    margin: 0;
    padding: 0;
    border: 0;

    display: inline-block;

    position: absolute;
    top: 50%;
    font-size: .7em;
    left: 100%;
    width: 25%;
    max-width: 100px;
    opacity: 0;
    margin-top: 2px;
    transform: translateX(37.5%);
    transition: opacity .25s ease-in-out 0s,transform .25s ease-in-out 0s,-webkit-transform .25s ease-in-out 0s;

    &:before {
      content: "";
      display: block;
      width: 100%;
      border-top: .15em solid;
      border-color: inherit;
    }

    &:after {
      content: "";
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 100%;
      height: 0;
      width: 0;
      border: .3em solid rgba(0,0,0,0);
      border-left-color: inherit;
      pointer-events: none;
    }
  }

  &:hover > span{
    opacity: 1;
    transform: translateX(66.7%);
  }
`

const NavbarLinks = () => {
  return (
    <>
      <NavItem to="/">Home<span></span></NavItem>
      <NavItem to="/about">About<span></span></NavItem>
      <NavItem to="/services">Services<span></span></NavItem>
      <NavItem to="/work">Work<span></span></NavItem>
      <NavItem to="/contact">Contact<span></span></NavItem>
    </>
  )
}

export default NavbarLinks